import React from "react";
import clsx from "clsx";
import {
  createStyles,
  Theme,
  ThemeProvider,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Grid, TextField, Button, CircularProgress } from "@material-ui/core";
import emptyTrash from "../assets/images/empty_trash.png";
import { EventEmitter } from "../events/EventEmitter";
import { ReportingService } from "../services/ReportingService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import PieChartComponent from "../reporting/PieChartComponent";
import history from "../utils/history";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FilterListIcon from "@material-ui/icons/FilterList";
import moment from "moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { EmployeeService } from "../services/EmployeeService";
import {
  getMomentDate,
  ROLES,
  MOD_GRAPHS,
  GRAPHS,
  GRAPH_TYPES,
  FILTER_TYPES,
  convertTextToTitleCase,
} from "../constants/constants";
import { isEmptyArray } from "formik";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import PrintIcon from "@material-ui/icons/Print";
import { defaultTheme } from "../utils/theme";
import BarGraphComponentV2 from "../reporting/BarGraphComponentV2";
import GraphDetailsDialogV2 from "../dialogs/GraphDetailsDialogV2";
import AddDataReporting from "../dialogs/AddDataReporting";
import { COV19ReportingService } from "../services/COV19ReportingService";
import { AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFQuestionaireDataDocument from "../print/PDFQuestionaireDataDocument";
import { VisitorService } from "../services/VisitorService";
import { DataConvertAsync } from "../utils/DataConvertAsync";
import LoadingComponents from "../components/LoadingComponents";
import CurveLineGraphComponent from "../reporting/CurveLineGraphComponent";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FilterSelectionComponent from "../components/FilterSelectionComponent";

const drawerWidth = 260;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    rtl: { value: theme.direction },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "rgba(0,255,255, 0.8)",
      },
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    container: {
      width: "100%",
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    title: {
      flex: "1 1 100%",
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    extendedIcon: {
      marginRight: 1,
    },
    table: {
      minWidth: 700,
    },
    underline: {
      "&&&:before": {
        borderBottom: "none",
      },
      "&&:after": {
        borderBottom: "none",
      },
    },
  });
const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    backgroundColor: "#11b92d",
    "&:hover": {
      backgroundColor: "#11b92d",
    },
  },
}))(Button);
interface Props extends WithStyles<typeof styles> {
  profileData: any;
  onLogOut: any;
  location?: any;
}
class ScreeningDashBoard extends React.Component<Props> {
  state = {
    open: false,
    selectedMenuItem: "Screening Dashboard",
    companyId: "",
    company: { name: "" },
    questionnaireData: Array<any>(),
    questionResponsesData: Array<any>(),
    personalisedQuestionnaireData: Array<any>(),
    alertsData: {
      highLeveInspections: Array<any>(),
      mediumLeveInspections: Array<any>(),
      lowerLeveInspections: Array<any>(),
    },
    isFiltering: false,
    isLoadingMBarData: false,
    isLoadingQuestionnaireReports: false,
    employeeFiltered: { _id: "", fullName: "" },
    filterStartDate: new Date(),
    filterEndDate: new Date(),
    employees: Array<any>(),
    visitors: Array<any>(),
    originalList: Array<any>(),
    originalListQuestionResponse: Array<any>(),
    employeeFilteredData: Array<any>(),
    employeeFilteredTemperatureData: Array<any>(),
    filteredTableData: Array<any>(),
    isLoading: false,
    openGraphDetailsDialog: false,
    openAddDataDialog: false,
    graphObject: { graph: {}, graphData: Array<any>(), title: "" },
    cov19Reporting: { data: new Array<any>() },

    selectedFilter: "",

    tableData: {
      totalPositiveCases: 0,
      activeCases: 0,
      tested: 0,
      positiveCases: 0,
      recovered: 0,
      deaths: 0,
    },
    referredData: Array<any>(),
    temperatureData: Array<any>(),
    companyAndDepartmentData: {
      departmentsData: Array<any>(),
      companyData: Array<any>(),
    },
    dateData: Array<any>(),
    mBarData: Array<any>(),

    tableDataLoading: false,
    referredDataLoading: false,
    temperatureDataLoading: false,
    companyAndDepartmentDataLoading: false,
    dateDataLoading: false,
    mBarDataLoading: false,
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  componentDidMount = () => {
    let startDate = moment(new Date()).subtract(7, "days").toDate();
    let endDate = moment(new Date()).toDate();
    this.setState(
      {
        filterStartDate: startDate,
        filterEndDate: endDate,
        isFiltering: true,
        selectedFilter: FILTER_TYPES.EVERY_DAY,
      },
      () => {
        this.getData();
      }
    );
  };
  componentWillMount = () => { };
  componentDidUpdate = (prevProps: any) => {
    let startDate = moment(new Date()).subtract(7, "days").toDate();
    let endDate = moment(new Date()).toDate();
    if (prevProps.profileData.companyId !== this.props.profileData.companyId) {
      this.setState(
        {
          filterStartDate: startDate,
          filterEndDate: endDate,
          isFiltering: true,
          selectedFilter: FILTER_TYPES.EVERY_DAY,
        },
        () => {
          this.getData();
        }
      );
    }
  };

  getData = () => {
    let companyId =
      this.props.profileData && this.props.profileData.companyId
        ? this.props.profileData.companyId
        : this.props.location &&
          this.props.location.state &&
          this.props.location.state.companyData._id
          ? this.props.location.state.companyData._id
          : "";
    if (companyId) {
      this.setState(
        {
          companyId: companyId,
        },
        () => {
          this.getEmployeesByCompany();
          this.getVisitorsByCompany();
          this.getCompanyDetails();
        }
      );
    }
  };
  getAlertData = () => {
    if (!this.state.companyId) {
      return;
    }
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getAlertsAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState({
              alertsData: resp.data,
            });
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );
  };
  getQuestionnaireReports = () => {
    if (!this.state.companyId) {
      return;
    }
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoadingQuestionnaireReports: true,
      companyAndDepartmentDataLoading: true,
      dateDataLoading: true,
    });
    reportingService.getQuestionnaireReportsByCompanyAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionnaireData: resp.data,
                originalList: resp.data,
                isLoadingQuestionnaireReports: true,
                companyAndDepartmentDataLoading: true,
                dateDataLoading: true,
              },
              () => {
                this.drawGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );
  };
  getQuestionnaireReportsBetweenTwoDates = () => {
    if (!this.state.companyId) {
      return;
    }
    var compareStartDate = getMomentDate(
      this.state.filterStartDate.toDateString(),
      "YYYY-MM-DD"
    );
    var compareEndDate = getMomentDate(
      this.state.filterEndDate.toDateString(),
      "YYYY-MM-DD"
    );
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });
    reportingService.getQuestionnaireReportsBetweenTwoDatesByCompanyAsync(
      this.state.companyId,
      compareStartDate,
      compareEndDate,
      this.state.employeeFiltered && this.state.employeeFiltered._id
        ? this.state.employeeFiltered._id
        : null,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionnaireData: resp.data,
                isLoadingQuestionnaireReports: true,
                companyAndDepartmentDataLoading: true,
                dateDataLoading: true,
              },
              () => {
                this.drawGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );
  };
  drawBarGraphs = () => {
    const data = this.state.questionnaireData;
    let dataConverterAsync: DataConvertAsync = new DataConvertAsync();
    const questionsResponses = this.state.questionResponsesData;
    dataConverterAsync
      .convertToBarChartsData(
        data,
        questionsResponses && questionsResponses.length > 0
          ? questionsResponses
          : []
      )
      .then((obj: any) => {
        this.setState({ mBarData: obj, isLoadingQuestionnaireReports: false });
      });
  };
  drawGraphs = () => {
    const data = this.state.questionnaireData;
    let dataConverterAsync: DataConvertAsync = new DataConvertAsync();
    dataConverterAsync
      .filterTableDataAsync(
        this.state.cov19Reporting.data,
        this.state.filterStartDate,
        this.state.filterEndDate
      )
      .then((obj: any) => {
        this.setState({
          filteredTableData: obj,
        });
      });
    this.setState({
      tableDataLoading: true,
    });
    data.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
    dataConverterAsync
      .getTableData(
        this.state.isFiltering
          ? this.state.filteredTableData
          : this.state.cov19Reporting.data
      )
      .then((obj: any) => {
        this.setState({
          tableData: obj,
          tableDataLoading: false,
        });
      });
    this.setState({
      isLoading: true,
      temperatureDataLoading: true,
    });
    if (this.state.employeeFiltered && this.state.employeeFiltered._id) {
      dataConverterAsync
        .getPersonTemperatureData(data)
        .then((resultObj: any) => {
          this.setState({
            employeeFilteredTemperatureData: resultObj,
            dateDataLoading: false,
          });
        });
    }

    dataConverterAsync.getReferredData(data).then((obj: any) => {
      this.setState(
        {
          referredData: obj,
          isLoading: false,
        },
        () => {
          dataConverterAsync
            .getTemperatureData(this.state.referredData)
            .then((tempObj: any) => {
              this.setState({
                temperatureData: tempObj,
                temperatureDataLoading: false,
              });
            });

          dataConverterAsync
            .convertToLineScreenedChartsData(data, this.state.referredData)
            .then((mObj: any) => {
              this.setState({
                dateData: mObj,
                dateDataLoading: false,
              });
            });
        }
      );
    });
    this.setState({
      isLoading: true,
    });
    dataConverterAsync
      .getDataByCompanyAndDepartment(data, this.state.company)
      .then((obj: any) => {
        this.setState({
          companyAndDepartmentData: obj,
          isLoading: false,
          companyAndDepartmentDataLoading: false,
        });
      });
  };

  getQuestionsResponses = () => {
    if (!this.state.companyId) {
      return;
    }
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
      isLoadingMBarData: true,
    });
    reportingService.getQuestionsResponsesAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
            isLoadingMBarData: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionResponsesData: resp.data,
                originalListQuestionResponse: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );
  };
  getVisitorsByCompany = () => {
    if (!this.state.companyId) {
      return;
    }
    let visitorService: VisitorService = new VisitorService();
    this.setState({
      isLoading: true,
    });

    visitorService.getVisitorsByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.visitors) {
            this.setState({
              visitors: resp.visitors,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => { }
    );
  };
  getEmployeesByCompany = () => {
    if (!this.state.companyId) {
      return;
    }
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });

    employeeService.getEmployeesByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.employees) {
            this.setState({
              employees: resp.employees,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => { }
    );
  };

  getCompanyDetails = () => {
    if (!this.state.companyId) {
      return;
    }
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });

    employeeService.getCompanyDetailsAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });

          if (resp && resp.success && resp.company) {
            this.setState(
              {
                company: resp.company,
                employeeFiltered: { _id: "", fullName: "" },
                originalList: Array<any>(),
                originalListQuestionResponse: Array<any>(),
                employeeFilteredData: Array<any>(),
                employeeFilteredTemperatureData: Array<any>(),
                filteredTableData: Array<any>(),
                dateData: Array<any>(),
              },
              () => {
                this.getCoV19ReportingData();
                this.getAlertData();
                if (!this.state.isFiltering) {
                  this.getQuestionsResponses();
                  this.getQuestionnaireReports();
                } else {
                  this.requestDataForDateRange();
                }
              }
            );
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => { }
    );
  };

  submitCOV19Reporting = (values: any) => {
    if (!this.state.companyId) {
      return;
    }
    let cov19ReportingService: COV19ReportingService =
      new COV19ReportingService();
    this.setState({
      isLoading: true,
    });

    cov19ReportingService
      .submitCov19Reporting(values, this.state.companyId)
      .then((resp: any) => {
        this.setState({
          isLoading: false,
          openAddDataDialog: false,
        });
        if (resp && resp.success) {
          this.setState({
            cov19Reporting: resp,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      });
  };

  getCoV19ReportingData = () => {
    if (!this.state.companyId) {
      return;
    }
    let cov19ReportingService: COV19ReportingService =
      new COV19ReportingService();
    this.setState({
      isLoading: true,
    });

    cov19ReportingService.getCov19ReportingByCompanyIdAsync(
      this.state.companyId,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success) {
            this.setState(
              {
                cov19Reporting: resp,
              },
              () => {
                this.drawGraphs();
              }
            );
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
      },
      () => { }
    );
  };

  onMenuItemClicked = (item: any) => {
    this.setState({
      selectedMenuItem: item.title,
    });
  };
  dataNotAvailable = () => {
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          style={{ marginTop: 10, textAlign: "center" }}
        >
          {"Data not available".toUpperCase()}
        </Typography>
      </div>
    );
  };
  valuetext = (value: number, index: number) => {
    return `${value}-Temp`;
    // switch (value) {
    //   case 30:
    //     return "All";
    //   case 60:
    //     return "2nd Day";
    //   case 90:
    //     return "Weeks";
    //   case 120:
    //     return "Months";
    //   default:
    //     return "Days";
    // }
  };

  renderPersonalisedGraph = (graphName: any) => {
    let mGraphName = graphName && graphName.title ? graphName.title : graphName;
    const data = this.state.questionnaireData;
    data.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
    switch (mGraphName) {
      case GRAPHS.QUESTIONNAIRE:
        return (
          <div
            style={{
              width: "100%",
              height: 500,
            }}
          >
            {this.state.mBarData && this.state.mBarData.length > 0 ? (
              <BarGraphComponentV2
                data={
                  this.state.mBarData && this.state.mBarData.length > 0
                    ? this.state.mBarData
                    : []
                }
                legendAxisLeft={"Number"}
                legendAxisBelow={"Questions"}
                indexBy={"Question"}
                keys={["YES", "NO"]}
                size={"L"}
                colors={(d: any) => {
                  return d.id === "NO" ? d.data.NOColor : d.data.YESColor;
                }}
              />
            ) : this.state.isLoadingMBarData ? (
              this.renderLoadingAwait()
            ) : (
              this.dataNotAvailable()
            )}
          </div>
        );
      case GRAPHS.PERSONS_SCREENED:
        return (
          <div style={{ width: "100%", height: 500 }}>
            {this.state.employeeFilteredTemperatureData ? (
              // <LineGraphComponent
              //   graphData={this.state.employeeFilteredTemperatureData}
              //   graph={"rotate"}
              //   yLabel={"Temperature (ºC)"}
              //   xLabel={"Date"}
              //   maxAllowedLine={true}
              //   colors={["green", "red"]}
              // />
              <CurveLineGraphComponent
                graphData={this.state.employeeFilteredTemperatureData}
                graph={"rotate"}
                yLabel={"Temperature (ºC)"}
                xLabel={"Date"}
                maxAllowedLine={true}
                timeScale={this.state.selectedFilter}
                colors={["green", "red"]}
              />
            ) : this.state.dateDataLoading ? (
              this.renderLoadingAwait()
            ) : (
              this.dataNotAvailable()
            )}
          </div>
        );
      default:
        return <div> Oops something wrong</div>;
    }
  };
  redirect = () => {
    let paramObj = {
      profileData: this.props.profileData,
      companyId: this.state.companyId,
      alertsData: this.state.alertsData,
    };
    history.push({
      pathname: `/dashboard/details`,
      state: paramObj,
    });
  };
  handleClick = () => {
    this.redirect();
  };

  handleApplyFilter = () => {
    this.setState(
      {
        isFiltering: !this.state.isFiltering,
        mBarData: [],
      },
      () => {
        if (!this.state.isFiltering) {
          this.setState({
            selectedFilter: FILTER_TYPES.EVERY_WEEK,
          });
          this.getCompanyDetails();
        } else {
          let startDate = moment(this.state.filterStartDate);
          let endDate = moment(this.state.filterEndDate);
          var duration = moment.duration(endDate.diff(startDate));
          var days = duration.asDays();
          this.setState(
            {
              selectedFilter:
                days > 7 ? FILTER_TYPES.EVERY_WEEK : FILTER_TYPES.EVERY_DAY,
            },
            () => {
              if (this.state.employeeFiltered._id) {
                this.applyEmployeeFilter(this.state.employeeFiltered);
              } else {
                this.setState({
                  isLoading: true,
                });
                this.requestDataForDateRange();
              }
            }
          );
        }
      }
    );
  };

  requestDataForDateRange = () => {
    let dataConverterAsync: DataConvertAsync = new DataConvertAsync();
    dataConverterAsync
      .filterTableDataAsync(
        this.state.cov19Reporting.data,
        this.state.filterStartDate,
        this.state.filterEndDate
      )
      .then((obj: any) => {
        this.setState({
          filteredTableData: obj,
        });
      });
    var compareStartDate = moment(this.state.filterStartDate).format(
      "YYYY-MM-DD"
    );
    var compareEndDate = moment(this.state.filterEndDate).format("YYYY-MM-DD");
    let reportingService: ReportingService = new ReportingService();
    reportingService.getQuestionnaireReportsBetweenTwoDatesByCompanyAsync(
      this.state.companyId,
      compareStartDate,
      compareEndDate,
      this.state.employeeFiltered && this.state.employeeFiltered._id
        ? this.state.employeeFiltered._id
        : null,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionnaireData: resp.data,
                isLoadingQuestionnaireReports: true,
                companyAndDepartmentDataLoading: true,
                dateDataLoading: true,
                dateData: Array<any>(),
              },
              () => {
                this.drawGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );

    reportingService.getQuestionsResponsesBetweenTwoDatesAsync(
      this.state.companyId,
      compareStartDate,
      compareEndDate,
      this.state.employeeFiltered && this.state.employeeFiltered._id
        ? this.state.employeeFiltered._id
        : null,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionResponsesData: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );
  };

  handleFilterStartDateChange = (date: Date | null) => {
    if (!this.state.employeeFiltered || !this.state.employeeFiltered._id) {
      this.setState({
        filterStartDate: date,
        isFiltering: false,
        questionnaireData: [...this.state.originalList],
      });
    } else {
      this.setState({
        filterStartDate: date,
        isFiltering: false,
        questionnaireData: [...this.state.employeeFilteredData],
      });
    }
  };
  handleFilterEndDateChange = (date: Date | null) => {
    if (!this.state.employeeFiltered || this.state.employeeFiltered._id) {
      this.setState({
        filterEndDate: date,
        isFiltering: false,
        questionnaireData: [...this.state.originalList],
      });
    } else {
      this.setState({
        filterEndDate: date,
        isFiltering: false,
        questionnaireData: [...this.state.employeeFilteredData],
      });
    }
  };

  getEmployeeDetails = () => {
    let employeeDetails = this.state.employees.filter((employee: any) => {
      return employee.fullName === this.state.employeeFiltered.fullName;
    });
    if (employeeDetails && employeeDetails.length > 0) {
      return employeeDetails[0];
    } else {
      return null;
    }
  };

  handleOnTextChanged = (event: any) => {
    let value = event.target.value;
    this.applyEmployeeFilter(value);
  };

  applyEmployeeFilter = (person: any) => {
    let reportingService: ReportingService = new ReportingService();
    this.setState({
      isLoading: true,
    });

    var compareStartDate = getMomentDate(
      this.state.filterStartDate.toDateString(),
      "YYYY-MM-DD"
    );
    var compareEndDate = getMomentDate(
      this.state.filterEndDate.toDateString(),
      "YYYY-MM-DD"
    );

    reportingService.getQuestionnaireReportsBetweenTwoDatesByCompanyAsync(
      this.state.companyId,
      compareStartDate,
      compareEndDate,
      person._id,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                employeeFiltered: person,
                questionnaireData: resp.data,
                employeeFilteredData: resp.data,
              },
              () => {
                this.drawGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );

    this.setState({
      isLoading: true,
    });
    reportingService.getQuestionsResponsesBetweenTwoDatesAsync(
      this.state.companyId,
      compareStartDate,
      compareEndDate,
      person._id,
      (res: any) => {
        res.then((resp: any) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success && resp.data) {
            this.setState(
              {
                questionResponsesData: resp.data,
              },
              () => {
                this.drawBarGraphs();
              }
            );
          } else {
            this.setState({
              showCompanies: false,
              showToolBarButton: false,
            });
            if (resp && resp.message) {
              EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
                show: true,
                type: SNACKBAR_TYPE.ERROR,
                message: resp.message,
              });
            }
          }
        });
      },
      () => { }
    );
  };
  onToolBarButtonClicked = () => {
    if (this.props.onLogOut) {
      this.props.onLogOut();
    }
    history.push({
      pathname: `/login`,
      state: {},
    });
  };

  openAddData = () => {
    clearInterval();
    this.setState({
      openAddDataDialog: true,
    });
  };

  print = () => { };
  onToolBarCloseButtonClicked = () => {
    history.goBack();
  };

  renderGraphDetailDialog = () => {
    return (
      <GraphDetailsDialogV2
        open={this.state.openGraphDetailsDialog}
        graphObject={this.state.graphObject}
        renderStatisticTable={
          this.state.employeeFiltered && this.state.employeeFiltered._id
            ? this.renderPersonalisedGraph
            : this.renderStatisticTable
        }
        handleClose={() => {
          this.setState({ openGraphDetailsDialog: false });
        }}
      />
    );
  };
  saveReportingData = (values: any) => {
    this.submitCOV19Reporting(values);
  };
  renderAddDataDialog = () => {
    let mData: any = this.state.cov19Reporting.data;
    return (
      <AddDataReporting
        dialogTitle={"Add data"}
        open={this.state.openAddDataDialog}
        onSaveData={this.saveReportingData}
        data={mData.data}
        handleClose={() => {
          this.setState({ openAddDataDialog: false });
        }}
      />
    );
  };

  getFilters = (selectedFilter: any, isFiltering: any) => {
    return [
      {
        title: convertTextToTitleCase(FILTER_TYPES.EVERY_DAY),
        selected: selectedFilter === FILTER_TYPES.EVERY_DAY ? true : false,
      },
      {
        title: convertTextToTitleCase(FILTER_TYPES.EVERY_WEEK),
        selected: selectedFilter === FILTER_TYPES.EVERY_WEEK ? true : false,
      },
      {
        title: convertTextToTitleCase(FILTER_TYPES.EVERY_MONTH),
        selected: selectedFilter === FILTER_TYPES.EVERY_MONTH ? true : false,
      },
      {
        title: convertTextToTitleCase(FILTER_TYPES.EVERY_YEAR),
        selected: selectedFilter === FILTER_TYPES.EVERY_YEAR ? true : false,
      },
    ];
  };

  getGraphTitle = (graph: any) => {
    return `${graph.subtitle} [${this.state.isFiltering
      ? getMomentDate(this.state.filterStartDate.toISOString(), "DD-MM-YYYY")
      : getMomentDate(this.state.questionnaireData[0].date)
      } to ${this.state.isFiltering
        ? getMomentDate(this.state.filterEndDate.toISOString(), "DD-MM-YYYY")
        : getMomentDate(
          this.state.questionnaireData[
            this.state.questionnaireData.length - 1
          ].date
        )
      }]`;
  };

  getPersonalidedGraphTitle = (employeeDetails: any, graph: any) => {
    return `${employeeDetails.fullName} ${employeeDetails.employeeNumber} ${graph.title === "QUESTIONNAIRE"
      ? "Questionanire Summary"
      : "Daily Temperature Measurement"
      } [${this.state.isFiltering
        ? getMomentDate(this.state.filterStartDate.toISOString(), "DD-MM-YYYY")
        : getMomentDate(this.state.questionnaireData[0].date)
      } to ${this.state.isFiltering
        ? getMomentDate(this.state.filterEndDate.toISOString(), "DD-MM-YYYY")
        : getMomentDate(
          this.state.questionnaireData[
            this.state.questionnaireData.length - 1
          ].date
        )
      }]`;
  };

  renderStatisticTable = (graph: any) => {
    const data = this.state.questionnaireData;
    switch (graph.title) {
      case MOD_GRAPHS.STATISTIC:
        return (
          <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <div style={{ display: "flex", flex: 0.2, flexDirection: "row" }}>
              <TableContainer
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  backgroundColor: "#bcbcbc",
                }}
              >
                <Table stickyHeader aria-label="sticky table">
                  <TableBody>
                    {[
                      { title: "Total Screening", value: data.length },
                      {
                        title: "Referred",
                        value: this.state.referredData.length,
                      },
                      {
                        title: "Temperature ≥ 38ºC",
                        value: this.state.temperatureData.length,
                      },
                      {
                        title: "Total Positive cases",
                        value: this.state.tableData.totalPositiveCases,
                      },
                      {
                        title: "Active cases",
                        value: this.state.tableData.activeCases,
                      },
                      { title: "Tested", value: this.state.tableData.tested },
                      {
                        title: "Positive Cases",
                        value: this.state.tableData.positiveCases,
                      },
                      {
                        title: "Recovered",
                        value: this.state.tableData.recovered,
                      },
                      { title: "Deaths", value: this.state.tableData.deaths },
                    ].map((row: any, index: any) => (
                      <TableRow
                        key={index.toString()}
                        style={{ width: "100%" }}
                      >
                        <TableCell
                          style={{
                            minWidth: 170,
                            borderRight: 2,
                            borderColor: "#ffffff",
                          }}
                        >
                          {row.title}
                        </TableCell>
                        <TableCell
                          align={"right"}
                          style={{
                            minWidth: 170,
                            borderRight: 2,
                            borderColor: "#ffffff",
                          }}
                        >
                          {row.value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div
              style={{
                display: "flex",
                flex: 0.8,
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              {this.state.tableData ? (
                <PieChartComponent
                  positiveCases={this.state.tableData.positiveCases}
                  referred={this.state.referredData.length}
                  recovered={this.state.tableData.recovered}
                  death={this.state.tableData.deaths}
                  screened={data.length}
                />
              ) : this.state.tableDataLoading ? (
                this.renderLoadingAwait()
              ) : (
                this.dataNotAvailable()
              )}
            </div>
          </div>
        );
      case MOD_GRAPHS.TEMPERATURE_MEASUREMENT:
        return (
          <div style={{ width: "100%", height: 500 }}>
            {this.state.dateData && this.state.dateData.length > 0 ? (
              // <LineGraphComponent
              //   graphData={this.state.dateData}
              //   graph={"rotate"}
              //   xLabel={"Date"}
              //   yLabel={"Person(s)"}
              //   maxAllowedLine={false}
              // />
              <CurveLineGraphComponent
                graphData={this.state.dateData}
                graph={"rotate"}
                xLabel={"Date"}
                yLabel={"Person(s)"}
                maxAllowedLine={false}
                timeScale={this.state.selectedFilter}
              />
            ) : this.state.dateDataLoading ? (
              this.renderLoadingAwait()
            ) : (
              this.dataNotAvailable()
            )}
          </div>
        );
      case MOD_GRAPHS.CASES_BY_DEPARTMENT:
        return (
          <div style={{ width: "100%", height: 500 }}>
            {this.state.companyAndDepartmentData &&
              this.state.companyAndDepartmentData.departmentsData &&
              this.state.companyAndDepartmentData.departmentsData.length > 0 ? (
              <BarGraphComponentV2
                data={this.state.companyAndDepartmentData.departmentsData}
                legendAxisLeft={"Cases"}
                legendAxisBelow={"Department"}
                indexBy={"department"}
                keys={["Screened", "Referred"]}
              />
            ) : this.state.companyAndDepartmentDataLoading ? (
              this.renderLoadingAwait()
            ) : (
              this.dataNotAvailable()
            )}
          </div>
        );
      case MOD_GRAPHS.CASES_BY_COMPANY:
        return (
          <div style={{ width: "100%", height: 500 }}>
            {this.state.companyAndDepartmentData &&
              this.state.companyAndDepartmentData.companyData &&
              this.state.companyAndDepartmentData.companyData.length > 0 ? (
              <BarGraphComponentV2
                data={this.state.companyAndDepartmentData.companyData}
                legendAxisLeft={"Cases"}
                legendAxisBelow={"Company"}
                indexBy={"contractType"}
                keys={["Screened", "Referred"]}
              />
            ) : this.state.companyAndDepartmentDataLoading ? (
              this.renderLoadingAwait()
            ) : (
              this.dataNotAvailable()
            )}
          </div>
        );
      case MOD_GRAPHS.SCREENING_QUESTIONNAIRE_FEEDBACK:
        return (
          <div
            style={{
              width: "100%",
              height: 500,
            }}
          >
            {this.state.mBarData && this.state.mBarData.length > 0 ? (
              <BarGraphComponentV2
                data={
                  this.state.mBarData && this.state.mBarData.length > 0
                    ? this.state.mBarData
                    : []
                }
                legendAxisLeft={"Number"}
                legendAxisBelow={"Questions"}
                indexBy={"Question"}
                keys={["YES", "NO"]}
                size={"L"}
                colors={(d: any) => {
                  return d.id === "NO" ? d.data.NOColor : d.data.YESColor;
                }}
              />
            ) : this.state.isLoadingQuestionnaireReports ? (
              this.renderLoadingAwait()
            ) : (
              this.dataNotAvailable()
            )}
          </div>
        );
      default:
        return <div> Oops something wrong</div>;
    }
  };

  renderLoadingAwait = () => {
    return (
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          height: 500,
        }}
      >
        <CircularProgress color="secondary" />
      </div>
    );
  };

  render() {
    const { classes, profileData } = this.props;
    return (
      <AuthConsumer>
        {({ user, accessRules }) => {
          return (
            <div className={classes.root}>
              <CssBaseline />
              <ThemeProvider theme={defaultTheme}>
                <AppBar
                  position="fixed"
                  className={clsx(classes.appBar, {
                    [classes.appBarShift]: this.state.open,
                  })}
                >
                  <Toolbar>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            alignItems: "flex-start",
                            textAlign: "start",
                            flex: 1,
                          }}
                        >
                          <Typography variant="h6" noWrap>
                            Main Dashboard
                          </Typography>
                        </div>

                        <div
                          style={{
                            flex: 0.5,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <HasPermission
                            role={user.role}
                            accessRules={accessRules}
                            perform="dashboard:print2"
                            yes={() => (
                              <PDFDownloadLink
                                document={
                                  <PDFQuestionaireDataDocument
                                    data={this.state.questionnaireData}
                                    company={this.state.company}
                                  />
                                }
                                style={{
                                  color: "black",
                                  textDecoration: "none",
                                }}
                                fileName="Dahboard.pdf"
                              >
                                {({ loading }) =>
                                  loading ? (
                                    <Button
                                      type="submit"
                                      disabled={true}
                                      onClick={() => this.print()}
                                      color="inherit"
                                    >
                                      <PrintIcon
                                        style={{ margin: 10 }}
                                        className={classes.extendedIcon}
                                      />
                                      Print
                                    </Button>
                                  ) : (
                                    <Button
                                      type="submit"
                                      onClick={() => this.print()}
                                      color="inherit"
                                    >
                                      <PrintIcon
                                        style={{ margin: 10 }}
                                        className={classes.extendedIcon}
                                      />
                                      Print
                                    </Button>
                                  )
                                }
                              </PDFDownloadLink>
                            )}
                            no={() => {
                              return null;
                            }}
                          ></HasPermission>
                          <HasPermission
                            role={user.role}
                            accessRules={accessRules}
                            perform="dashboard:create"
                            yes={() => (
                              <Button
                                type="submit"
                                onClick={() => this.openAddData()}
                                color="inherit"
                              >
                                <AddIcon
                                  style={{ margin: 10 }}
                                  className={classes.extendedIcon}
                                />
                                Add Data
                              </Button>
                            )}
                            no={() => {
                              return null;
                            }}
                          ></HasPermission>

                          {profileData &&
                            profileData.role &&
                            profileData.role === ROLES.DASHBOARD ? (
                            <Button
                              type="submit"
                              onClick={() => this.onToolBarButtonClicked()}
                              color="inherit"
                            >
                              <LockOpenIcon
                                style={{ margin: 10 }}
                                className={classes.extendedIcon}
                              />
                              Logout
                            </Button>
                          ) : (
                            <Button
                              type="submit"
                              onClick={() => this.onToolBarCloseButtonClicked()}
                              color="inherit"
                            >
                              <CloseIcon
                                style={{ margin: 10 }}
                                className={classes.extendedIcon}
                              />
                              Close
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Toolbar>
                </AppBar>
              </ThemeProvider>
              <div className={classes.content}>
                <div className={classes.toolbar} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    marginTop: -25,
                    height: 100,
                    justifyContent: "center",
                    flexDirection: "row",
                    zIndex: 1,
                  }}
                >
                  <Paper
                    elevation={3}
                    style={{
                      margin: 10,
                      borderRadius: 12,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Autocomplete
                      id="combo-box-demo"
                      options={this.state.employees}
                      getOptionLabel={(employee) => employee.fullName}
                      value={
                        this.state.employeeFiltered.fullName
                          ? this.state.employeeFiltered
                          : null
                      }
                      style={{ width: 300 }}
                      onChange={(event: any, value: any) => {
                        if (!value) {
                          this.setState(
                            {
                              employeeFiltered: { _id: "", fullName: "" },
                              questionnaireData: this.state.originalList,
                              employeeFilteredTemperatureData: [],
                              questionResponsesData:
                                this.state.originalListQuestionResponse,
                              isLoadingQuestionnaireReports: true,
                              companyAndDepartmentDataLoading: true,
                              dateDataLoading: true,
                              isFiltering: false,
                            },
                            () => {
                              this.handleApplyFilter();
                            }
                          );
                        } else {
                          this.applyEmployeeFilter(value);
                        }
                      }}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          autoFocus={true}
                          id="standard-full-width"
                          label="Filter Employee"
                          style={{ paddingRight: 20, margin: 10 }}
                          placeholder="Search..."
                          fullWidth
                          margin="normal"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                          }}
                        />
                      )}
                    />
                  </Paper>
                  <div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid
                        container
                        justify="flex-start"
                        style={{ margin: 10 }}
                      >
                        <Paper
                          elevation={3}
                          style={{
                            margin: 10,
                            borderRadius: 12,
                            alignSelf: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <KeyboardDatePicker
                            style={{ margin: 10 }}
                            disableToolbar
                            variant="inline"
                            format="dd/MM/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="From"
                            autoOk
                            value={this.state.filterStartDate}
                            onChange={this.handleFilterStartDateChange}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Paper>
                        <Paper
                          elevation={3}
                          style={{
                            margin: 10,
                            borderRadius: 12,
                            alignSelf: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <KeyboardDatePicker
                            style={{ margin: 10 }}
                            disableToolbar
                            variant="inline"
                            format="dd/MM/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="To"
                            minDate={this.state.filterStartDate}
                            autoOk
                            value={this.state.filterEndDate}
                            onChange={this.handleFilterEndDateChange}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Paper>
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </div>
                  <Paper
                    elevation={3}
                    style={{
                      borderRadius: 12,
                      height: 60,
                      padding: 5,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      backgroundColor: this.state.isFiltering
                        ? "#11b92d"
                        : "white",
                      flexDirection: "column",
                    }}
                  >
                    {this.state.isFiltering ? (
                      <Button
                        onClick={() => this.handleApplyFilter()}
                        style={{ borderColor: "#11b92d", color: "white" }}
                        variant="outlined"
                        startIcon={
                          <FilterListIcon style={{ color: "white" }} />
                        }
                      >
                        Filter
                      </Button>
                    ) : (
                      <Button
                        onClick={() => this.handleApplyFilter()}
                        style={{ borderColor: "white", color: "grey" }}
                        variant="outlined"
                        startIcon={<FilterListIcon />}
                      >
                        Filter
                      </Button>
                    )}
                  </Paper>
                </div>
                <div className={classes.toolbar} />
                {this.state.questionnaireData &&
                  this.state.questionnaireData.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        height: "100%",
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Grid
                        container
                        className={classes.root}
                        spacing={2}
                        xs={12}
                        item
                        style={{
                          margin: 10,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {!this.state.employeeFiltered ||
                          (!this.state.employeeFiltered._id &&
                            [
                              {
                                title: "STATISTIC",
                                color: "black",
                                type: GRAPH_TYPES.TABLE,
                                subtitle: `${this.state.company.name} Statistics`,
                                hidden: false,
                              },
                              {
                                title: "TEMPERATURE_MEASUREMENT",
                                color: "black",
                                type: GRAPH_TYPES.LINE,
                                subtitle:
                                  "Number of persons screened and referred",
                                hidden: false,
                              },
                              {
                                title: "CASES_BY_DEPARTMENT",
                                color: "black",
                                type: GRAPH_TYPES.BAR,
                                subtitle: "Cases per department",
                                hidden: true,
                              },
                              {
                                title: "CASES_BY_COMPANY",
                                color: "black",
                                type: GRAPH_TYPES.BAR,
                                subtitle: "Cases per company",
                                hidden: false,
                              },
                              {
                                title: "SCREENING_QUESTIONNAIRE_FEEDBACK",
                                color: "black",
                                type: GRAPH_TYPES.BAR,
                                subtitle: "Screening questionnaire",
                                hidden: false,
                              },
                            ].map((graph: any, index: Number) => {
                              let graphTitle = this.getGraphTitle(graph);
                              return (
                                <Grid key={index.toString()} item xs={10}>
                                  {!graph.hidden && (
                                    <div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flex: 1,
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <Typography
                                            variant={"h6"}
                                          >{`${graphTitle}`}</Typography>
                                        </div>
                                        {!graph.hidden && (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "flex-end",
                                            }}
                                          >
                                            <div
                                              style={{ flexDirection: "row" }}
                                            ></div>
                                            <ColorButton
                                              variant="contained"
                                              color="default"
                                              onClick={() => {
                                                let graphObject =
                                                  this.state.graphObject;
                                                graphObject.graph = graph;
                                                graphObject.title = graphTitle;
                                                graphObject.graphData =
                                                  this.state.questionnaireData;
                                                this.setState({
                                                  graphObject: graphObject,
                                                  openGraphDetailsDialog: true,
                                                });
                                              }}
                                              startIcon={<FullscreenIcon />}
                                            >
                                              Full screen
                                            </ColorButton>
                                          </div>
                                        )}
                                      </div>
                                      {graph.type === GRAPH_TYPES.LINE && (
                                        <div
                                          style={{
                                            marginTop: 20,
                                            marginBottom: 20,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <FilterSelectionComponent
                                            onSelectedFilter={(
                                              selectedFilter: any
                                            ) => {
                                              this.setState({
                                                selectedFilter:
                                                  selectedFilter.title.toLowerCase(),
                                              });
                                            }}
                                            filters={this.getFilters(
                                              this.state.selectedFilter,
                                              this.state.isFiltering
                                            )}
                                          />
                                        </div>
                                      )}

                                      {this.state.questionnaireData &&
                                        this.state.questionnaireData.length >
                                        0 &&
                                        this.renderStatisticTable(graph)}
                                    </div>
                                  )}
                                </Grid>
                              );
                            }))}
                        {this.state.employeeFiltered &&
                          this.state.employeeFiltered._id &&
                          [
                            {
                              title: "QUESTIONNAIRE",
                              color: "black",
                              type: GRAPH_TYPES.BAR,
                            },
                            {
                              title: "PERSONS_SCREENED",
                              color: "white",
                              type: GRAPH_TYPES.LINE,
                            },
                          ].map((graph: any, index: Number) => {
                            let employeeDetails = this.getEmployeeDetails();
                            let graphTitle = this.getPersonalidedGraphTitle(
                              employeeDetails,
                              graph
                            );
                            return (
                              <Grid key={index.toString()} item xs={10}>
                                <div
                                  style={{
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flex: 1,
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {employeeDetails && (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <Typography
                                            variant={"h6"}
                                          >{`${graphTitle}`}</Typography>
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <ColorButton
                                        variant="contained"
                                        color="default"
                                        onClick={() => {
                                          let graphObject =
                                            this.state.graphObject;
                                          graphObject.graph = graph;
                                          graphObject.title = graphTitle;
                                          graphObject.graphData =
                                            this.state.questionnaireData;
                                          this.setState({
                                            graphObject: graphObject,
                                            openGraphDetailsDialog: true,
                                          });
                                        }}
                                        startIcon={<FullscreenIcon />}
                                      >
                                        Full screen
                                      </ColorButton>
                                    </div>
                                  </div>
                                  {graph.type === GRAPH_TYPES.LINE && (
                                    <div
                                      style={{
                                        marginTop: 20,
                                        marginBottom: 20,
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <FilterSelectionComponent
                                        onSelectedFilter={(
                                          selectedFilter: any
                                        ) => {
                                          this.setState({
                                            selectedFilter:
                                              selectedFilter.title.toLowerCase(),
                                          });
                                        }}
                                        filters={this.getFilters(
                                          this.state.selectedFilter,
                                          this.state.isFiltering
                                        )}
                                      />
                                    </div>
                                  )}
                                  {this.state.employeeFilteredTemperatureData &&
                                    this.state.employeeFilteredTemperatureData
                                      .length > 0 &&
                                    this.state.employeeFiltered &&
                                    this.state.employeeFiltered._id &&
                                    this.renderPersonalisedGraph(graph.title)}
                                </div>
                                <div
                                  style={{
                                    height: "2%",
                                  }}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                    </div>
                  )}
                {isEmptyArray(this.state.questionnaireData) && (
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "auto",
                    }}
                  >
                    <img
                      src={emptyTrash}
                      style={{ width: 40, height: 40 }}
                      alt="Empty Trash"
                    />
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: 10, textAlign: "center" }}
                    >
                      {"No data available".toUpperCase()}
                    </Typography>
                  </div>
                )}
              </div>
              {this.renderGraphDetailDialog()}
              {this.renderAddDataDialog()}
              <LoadingComponents isLoading={this.state.isLoading} />
            </div>
          );
        }}
      </AuthConsumer>
    );
  }
}
export default withStyles(styles)(ScreeningDashBoard);
